/*
*
* Notifications
*
*/

import React from 'react';
import { connect } from 'react-redux';
import { setTitle, setLoader, setBreadcrumb, delayedDispatch, updateCrumb } from 'store/actions';
import { Table } from 'components';
import { Helmet } from 'react-helmet';
import { push } from 'connected-react-router';
import { API, Endpoints } from "utils/api";
import { toast } from 'utils/utils';
import moment from 'moment';
import Strings from 'utils/strings';
import './styles.scss';

export class Notifications extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			windowWidth: window.innerWidth < 900 ? window.innerWidth - 20 : 900,
			tempNotification: {},
			locations: [{
				_id: 1,
				name: 'location 1',
			}, {
				_id: 2,
				name: 'location 2',
			}],
			preferences: [{
				_id: 1,
				name: 'preference 1',
			}, {
				_id: 2,
				name: 'preference 2',
			}],
			language: 'pt',
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		// change this
		dispatch(setTitle(Strings.sidebar.notifications));
		delayedDispatch(
			setBreadcrumb(() => {
				return {
					locations: [
						{
						  text: Strings.sidebar.notifications,
						//   route: "/settings/cultures",
						  icon: "bell",
						},
					],
				}
			})
		);

		this.getNotifications();
	}

	componentDidUpdate() {
		const { dispatch } = this.props;
	
		dispatch(updateCrumb());
	}

	async getNotifications() {
		// GET Notifications
		const { dispatch } = this.props;

		dispatch(setLoader(true))

		const response = await API.get({
			url: Endpoints.uriNotifications(),
		});
	  
		if (response.ok) {
			this.setState({ notifications: response.data.results });
		} else {
			return toast.error(response.data?.message || Strings.serverErrors.title);
		}

		dispatch(setLoader(false))
	}

	async deleteNotification(id: any) {
		// DELETE Notifications
		const { dispatch } = this.props;

		dispatch(setLoader(true))

		const response = await API.delete({
			url: Endpoints.uriNotifications(id),
		});
	  
		if (response.ok) {
			this.setState({ notifications: response.data.results });
		} else {
			return toast.error(response.data?.message || Strings.serverErrors.title);
		}

		dispatch(setLoader(false))
	}

	render() {
		const { notifications } = this.state;
		const { dispatch } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.notifications}</title>
					<meta name="description" content="Description of Notifications" />
				</Helmet>
				<Table
					title={{
						icon: "bell",
						title: Strings.sidebar.notifications
					}}
					data={notifications}
					columns={[
						{
							Header: Strings.notifications.header,
							id: 'name',
							accessor: (row: any) => row.title.pt,
						},
						{
							Header: Strings.notifications.sending,
							id: 'scheduleDate',
							accessor: (row: any) => moment(row.scheduleDate).format('DD/MM/yyyy - HH:mm'),
						},
					]}
					filterable
					add={{
						label: String(Strings.formatString(Strings.generic.addNew, Strings.notifications.header.toLowerCase())),
						onClick: () => dispatch(push('notifications/new')),
					}}
					actions={{
						edit: (original, value) => ({
							onClick: () => dispatch(push(`notifications/${original._id}`)),
						}),
						remove: (original, value) => ({
							onClick: () => this.deleteNotification(original._id),
						}),
					}}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(Notifications);